/**
 * Returns the HTML for add to cart button and quantity input
 * @param {String} addToCartButtonHTML
 */
const defineHTMLForAddToCartButton = (addToCartButtonHTML) => {
    return addToCartButtonHTML;
};

export { defineHTMLForAddToCartButton };
